import React from "react";
import styles from "./PlanCard.module.scss";

const PlanCard = () => {
  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.name}>
          <h5>Standard Plan</h5>
          <small>/month</small>
        </div>
        <div className={styles.amount}>
          <h4>$29</h4>
        </div>
      </div>
      <div className={styles.bottom}>
        <ul>
          <li>Upto 10,000 uploads</li>
          <li>10 GB cloud storage</li>
          <li>25 collections</li>
        </ul>

        <div className={styles.progressContainer}>
          <div className={styles.circular}>
            <div className={styles.inner}></div>
            <div className={styles.number}>
              23
              <small>days left</small>
            </div>
            <div className={styles.circle}>
              <div className={`${styles.bar} ${styles.left}`}>
                <div className={styles.progress}></div>
              </div>
              <div className={`${styles.bar} ${styles.right}`}>
                <div className={styles.progress}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
